import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { H3_TITLE, CountryCodes } from '@Apis/constants';
import { Helmet } from 'react-helmet';
import './style.scss';
import PropTypes from 'prop-types';
import TenantActions from '@Actions/tenantActions';
import { Drawer, Popconfirm } from 'antd';
import AddressActions from '@Actions/addressActions';
import UserActions from '@Actions/userActions';
import {
  EditOutlined,
} from '@ant-design/icons';
import UserForm from '@Components/Settings/ManageTeam/UserForm';
import AddUser from '@Components/Settings/ManageTeam/AddUser';
import UpdateUser from '@Components/Settings/ManageTeam/UpdateUser';
import NewAddressForm from '@Components/Common/FormUtils/NewAddressForm';
import UpdateAddressForm from '@Components/Common/UpdateAddressForm';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
/**
 *
 */
class BusinessUnitOverview extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  /**
   *
   */
  componentDidMount() {
    const { getUsers, selectedTenant } = this.props;
    getUsers(selectedTenant?.tenant_id);
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    if (props.selectedTenant?.tenant_id !== state.selectedTenant?.tenant_id) {
      props.getUsers(props.selectedTenant?.tenant_id);
      props.getAddresses(1, props.selectedTenant?.tenant_id, 'TENANT');
      return {
        ...state,
        selectedTenant: props.selectedTenant,
      };
    }
    return state;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      selectedTenant, getUsers, users, tenantAddresses, showUpdateTenantModal,
      getAddresses, getUsersLoading, getAddressesLoading, updateUser, user,
    } = this.props;
    const {
      newUserModal, updateUserModal, selectedUser, showNewAddressModal,
      selectedAddress, showUpdateAddressModal,
    } = this.state;
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{H3_TITLE}</title>
        </Helmet>
        <Drawer
          open={showNewAddressModal}
          onClose={() => this.setState({ showNewAddressModal: false })}
          showHeader
          width="480px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '435px' }}>
              <H3Text text="Add New Address" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showNewAddressModal: false })} />
            </div>
          </div>
          <NewAddressForm
            addressType="TENANT"
            callback={
              () => {
                this.setState({ showNewAddressModal: false });
                getAddresses(1, selectedTenant?.tenant_id, 'TENANT');
              }
            }
            selectedTenantId={selectedTenant?.tenant_id}
            tenantId={selectedTenant?.tenant_id}
          />
        </Drawer>
        <Drawer
          open={showUpdateAddressModal}
          title="Update Address"
          onClose={() => this.setState({ showUpdateAddressModal: false })}
          showHeader
          width="480px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '435px' }}>
              <H3Text text="Update Address" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showUpdateAddressModal: false })} />
            </div>
          </div>
          <UpdateAddressForm
            addressType="TENANT"
            selectedAddress={selectedAddress}
            callback={
              () => {
                this.setState({ showUpdateAddressModal: false });
                getAddresses(1, selectedTenant?.tenant_id, 'TENANT');
              }
            }
            selectedTenantId={selectedTenant?.tenant_id}
            tenantId={selectedTenant?.tenant_id}
          />
        </Drawer>

        <Drawer
          open={newUserModal}
          title=""
          onClose={() => this.setState({ showNewProductModal: false, newUserModal: false })}
          width="320px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '270px' }}>
              <H3Text text="Add New User" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showUpdateAddressModal: false })} />
            </div>
          </div>
          <UserForm
            setShowNewProductModal={(value) => this.setState({ showNewProductModal: value })}
            setShowNewOfferModal={(value) => this.setState({ newUserModal: value })}
            callback={() => {
              this.setState({ newUserModal: false });
              getUsers(selectedTenant?.tenant_id);
            }}
            selectedTenant={selectedTenant}
          />
        </Drawer>

        <Drawer
          open={updateUserModal}
          title="Update User"
          onClose={() => this.setState({ updateUserModal: false })}
          width="320px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '270px' }}>
              <H3Text text="Update User" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ updateUserModal: false })} />
            </div>
          </div>
          <UserForm
            setShowNewProductModal={(value) => this.setState({ showNewProductModal: value })}
            setShowNewOfferModal={(value) => this.setState({ showNewRoleModal: value })}
            callback={
              () => {
                this.setState({ updateUserModal: false });
                getUsers(selectedTenant?.tenant_id);
              }
            }
            selectedTenant={selectedTenant}
            selectedUser={selectedUser}
          />
        </Drawer>
        <div className="business-overview__wrapper">
          <div className="ant-row">
            <div className="ant-col-md-10">
              <div className="business-overview__left">
                <div className="business-overview__left-header">
                  <div className="business-overview__left-heading">
                    UNIT INFORMATION
                  </div>
                  <div className="business-overview__left-sub" onClick={() => showUpdateTenantModal()}>
                    Edit
                  </div>
                </div>
                <div className=" business-overview__left__unit-info">
                  { selectedTenant?.tenant_id
                    ? (
                      <React.Fragment>
                        <div className="unit-info-row">
                          <div className="unit-info-row__label">
                            Contact
                          </div>
                          <div className="unit-info-row__value">
                            {selectedTenant?.mobile && (`${CountryCodes?.find((code) => code?.dial_code == selectedTenant?.dial_code)?.flag} +${selectedTenant?.dial_code} ${selectedTenant?.mobile}`)}
                          </div>
                        </div>
                        <div className="unit-info-row">
                          <div className="unit-info-row__label">
                            Email
                          </div>
                          <div className="unit-info-row__value">
                            {selectedTenant?.email}
                          </div>
                        </div>
                        <div className="unit-info-row">
                          <div className="unit-info-row__label">
                            GST Number
                          </div>
                          <div className="unit-info-row__value">
                            {selectedTenant?.gst_number}
                          </div>
                        </div>
                        <div className="unit-info-row">
                          <div className="unit-info-row__label">
                            Legal / Trade Name
                          </div>
                          <div className="unit-info-row__value">
                            {selectedTenant?.legal_name}
                          </div>
                        </div>
                      </React.Fragment>
                    )

                    : (
                      <React.Fragment>
                        {[1, 2, 3, 4]?.map((item) => (
                          <div key={item} className="business-overview__loader">
                            <div className="loadingBlock loader-line" />
                          </div>
                        ))}

                      </React.Fragment>
                    ) }

                </div>
                <br />
                <br />
                {/* <div className="business-overview__left-header">
                  <div className="business-overview__left-heading">
                    CONTACT PERSONS
                  </div>
                  <div
                    className="business-overview__left-sub"
                    onClick={() => this.setState({ newUserModal: true })}
                  >
                    +Add New
                  </div>
                </div> */}
                {/* <div className="business-overview__left__users">
                  {getUsersLoading
                    ? (
                      <React.Fragment>
                        {[1, 2]?.map((item) => (
                          <div key={item} className="business-overview__loader">
                            <div className="loadingBlock loader-line-user  user-row" />
                          </div>
                        ))}

                      </React.Fragment>
                    )
                    : (
                      <React.Fragment>
                        {users?.data?.[0]?.tenant_user?.map((user) => (
                          <div key={user?.user_id} className={`user-row ${user?.is_active ? '' : 'is__deleted-row' }`}>
                            <div className="user-row__left">
                              <div className="user-row__left-icon">{`${user?.first_name?.substring(0, 1)?.toProperCase() } ${ user?.last_name ? user?.last_name?.substring(0, 1)?.toProperCase() : ''}` }</div>
                            </div>
                            <div className="user-row__right">
                              <div className="user-row__right-name">{`${user?.first_name?.toProperCase() } ${ user?.last_name ? user?.last_name?.toProperCase() : ''}`}</div>
                              <div className="user-row__right-options">
                                <div className="user-row__right-option" onClick={() => user?.is_active && this.setState({ updateUserModal: true, selectedUser: user })}>
                                  Edit
                                </div>
                                &nbsp;
                                |
                                &nbsp;
                                <Popconfirm
                                  title={`Confirm ${user?.is_active ? 'deactivate' : 'activate'} user?`}
                                  onConfirm={() => {
                                    updateUser([{
                                      user_id: user?.user_id,
                                      is_active: !user?.is_active,
                                      tenant_id: selectedTenant?.tenant_id,
                                    }], () => {
                                      getUsers(selectedTenant?.tenant_id);
                                    });
                                  }}
                                >
                                  <div
                                    className="user-row__right-option"
                                  >
                                    Mark as
                                    {' '}
                                    {user?.is_active ? 'Inactive' : 'Active'}
                                  </div>
                                </Popconfirm>

                              </div>

                            </div>
                          </div>
                        ))}
                      </React.Fragment>
                    )}

                </div> */}
                <br />
                <br />
              </div>
            </div>
            <div className="ant-col-md-14">
              <div className="business-overview__right">
                <div className="business-overview__right-header">
                  <div className="business-overview__right-heading">
                    ADDRESSES
                  </div>
                  <div className="business-overview__right-sub" onClick={() => this.setState({ showNewAddressModal: true })}>
                    + Add New
                  </div>
                </div>
                <div className="business-overview__right-comments">
                  {getAddressesLoading
                    ? (
                      <React.Fragment>
                        {[1, 2]?.map((item) => (
                          <div key={item} className="business-overview__loader">
                            <div className="loadingBlock loader-line-user  business-overview__right-comment" />
                          </div>
                        ))}

                      </React.Fragment>
                    )
                    : (
                      <React.Fragment>
                        {tenantAddresses?.addresses?.map((address) => (
                          <div key={address?.address_id} className="business-overview__right-comment">
                            <div className="business-overview__right-comment-message">
                              {address?.address1}
                              <br />
                              {`${address?.city}, ${address?.state} ${address?.postal_code}`}
                            </div>
                            <div className="business-overview__right-comment-options">
                              <div className="comment-option roundIconButton" onClick={() => this.setState({ showUpdateAddressModal: true, selectedAddress: address })}>
                                <EditOutlined />
                              </div>

                            </div>
                          </div>
                        ))}
                      </React.Fragment>
                    )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, TenantReducers, AddressReducer,
}) => ({
  user: UserReducers.user,
  users: TenantReducers.users,
  tenants: TenantReducers.tenants,
  getTenantsLoading: TenantReducers.getTenantsLoading,
  getUsersLoading: UserReducers.getUsersLoading,
  tenantAddresses: AddressReducer.tenantAddresses,
  getAddressesLoading: AddressReducer.getAddressesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getUsers: (tenantId, roleId) => dispatch(TenantActions.getUsers(tenantId, roleId)),
  getAddresses: (page, entityId, entityType, addressId) => dispatch(AddressActions.getAddresses(
    page, entityId, entityType, addressId,
  )),
  updateUser: (payload, callback) => dispatch(UserActions.updateUser(payload, callback)),

});

BusinessUnitOverview.propTypes = {
  selectedTenant: PropTypes.any,
  users: PropTypes.any,
  tenantAddresses: PropTypes.any,
  getUsers: PropTypes.func,
  getAddresses: PropTypes.func,
  showUpdateTenantModal: PropTypes.func,
  getUsersLoading: PropTypes.bool,
  getAddressesLoading: PropTypes.bool,
  updateUser: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusinessUnitOverview));
